/**
 * Canonical inbox-list sort order.
 *
 * Pinned conversations first (most-recently-pinned at the top of the
 * pinned section), then the rest ordered by `lastMessageAt` descending,
 * falling back to `updatedAt` when a row has no messages yet.
 *
 * Matches the server-side ORDER BY in listConversations so a client-side
 * resort lands in the same position the next network fetch would.
 */

import type { Conversation } from '@/lib/api/conversations';

export function compareConversations(a: Conversation, b: Conversation): number {
  if (!!a.isPinned !== !!b.isPinned) return a.isPinned ? -1 : 1;
  if (a.isPinned && b.isPinned) {
    const ap = a.pinnedAt ?? '';
    const bp = b.pinnedAt ?? '';
    if (ap !== bp) return bp.localeCompare(ap);
  }
  const at = a.lastMessageAt ?? a.updatedAt ?? '';
  const bt = b.lastMessageAt ?? b.updatedAt ?? '';
  return bt.localeCompare(at);
}

export function sortConversations(rows: Conversation[]): Conversation[] {
  return rows.slice().sort(compareConversations);
}
